import { PostStoryblok } from '@/types/types-storyblok';
import { StoryblokStory } from 'storyblok-generate-ts';
import Link from 'next/link';
import Image from 'next/image';
import { getImageDimensions } from '@/storyblok/utils/asset';
import clsx from 'clsx';

export const PostCard = ({ post, direction }: { post: StoryblokStory<PostStoryblok>; direction?: 'vertical' | 'horizontal' }) => (
  <li className="px-4 md:px-0 group">
    <Link
      className={clsx('flex h-full flex-col gap-4', direction === 'horizontal' && 'md:flex-row md:gap-x-8')}
      href={'/' + post.full_slug}
    >
      <div className="relative">
        <div className="bg-black/40 opacity-0 hover:opacity-100 absolute top-0 left-0 w-full h-full z-10 transition-opacity duration-300 group-hover:opacity-100 rounded-xl" />
        {post.content.image?.filename ? (
          <Image
            className="rounded-xl aspect-[1.6] object-cover bg-gray-300"
            src={post.content.image.filename}
            alt={post.content.image.alt ?? 'immagine guida'}
            {...getImageDimensions(post.content.image)}
          />
        ) : (
          <div className="rounded-xl aspect-[1.6] bg-gray-300" />
        )}
      </div>
      <div className="flex flex-row justify-between items-center">
        <span className="text-elty-green text-xs bg-brandGreen-100 py-1 px-2 rounded flex-grow-0 whitespace-nowrap">
          {post.content.categories?.map(category => (typeof category === 'string' ? category : category.name)).join(', ')}
        </span>
        {post.first_published_at && (
          <time className="text-text-body text-sm whitespace-nowrap">
            {new Date(post.first_published_at).toLocaleString('it', {
              month: '2-digit',
              day: '2-digit',
              year: '2-digit',
            })}
          </time>
        )}
      </div>
      <h3 className="text-brandBlue-900 text-xl font-semibold">{post.content.title}</h3>
      <span className="text-elty-green font-semibold flex-grow flex flex-row justify-start items-center gap-2 transition-transform group-hover:translate-x-1">
        Leggi adesso
        <ArrowRightIcon />
      </span>
    </Link>
  </li>
);

const ArrowRightIcon = () => (
  <svg className="size-5" fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" fill="#0bbca7" r="12" transform="matrix(-1 0 0 -1 24 24)" />
    <path d="m4.80005 4.80005h14.4v14.4h-14.4z" fill="#0bbca7" />
    <path
      clipRule="evenodd"
      d="m14.5682 11.6819c.1758.1757.1758.4606 0 .6363l-4.5 4.5c-.17569.1758-.46061.1758-.63635 0-.17574-.1757-.17574-.4606 0-.6364l4.18185-4.1818-4.18185-4.18175c-.17573-.17574-.17573-.46066 0-.6364.17574-.17574.46066-.17574.63635 0z"
      fill="#fff"
      fillRule="evenodd"
    />
  </svg>
);
